import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-danger text-center py-4"
}
const _hoisted_2 = { id: "calculator-header" }
const _hoisted_3 = { class: "meta bg-primary text-white" }
const _hoisted_4 = { class: "container-fluid" }
const _hoisted_5 = {
  class: "row",
  style: {"align-items":"center"}
}
const _hoisted_6 = ["title"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "icon-office" }, null, -1 /* HOISTED */)
const _hoisted_8 = { "data-testid": "header-company-name-text" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_10 = {
  key: 0,
  class: "col-md-auto col-5 text-truncate"
}
const _hoisted_11 = {
  class: "col-md-auto col-xs-6 text-end",
  style: {"margin-left":"auto"}
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "row step"
}
const _hoisted_14 = { class: "col" }
const _hoisted_15 = {
  class: "h2 mt-3",
  "data-testid": "page-title-text"
}
const _hoisted_16 = { class: "col-12 my-3" }
const _hoisted_17 = {
  key: 0,
  style: {"padding-top":"0.5em","color":"red","text-align":"center"}
}
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { class: "container-fluid" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-12" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "border-top pt-3" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.showModal)
      ? (_openBlock(), _createBlock($setup["CompanyCode"], {
          key: 0,
          onHideModal: $setup.toggleModal
        }))
      : _createCommentVNode("v-if", true),
    ($setup.formNotFound)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString($setup.t("message.formNotFound")), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "col-md col-5 text-truncate",
              title: $setup.employer?.company
            }, [
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString($setup.t("message.company")) + ": ", 1 /* TEXT */),
              _createElementVNode("strong", _hoisted_8, _toDisplayString($setup.employer?.company ?? "---"), 1 /* TEXT */),
              _createVNode($setup["ChangeCompanyButton"], {
                modal: $setup.modal,
                toggleModal: $setup.toggleModal,
                "display-edit-button": true
              }, null, 8 /* PROPS */, ["modal"]),
              _hoisted_9
            ], 8 /* PROPS */, _hoisted_6),
            ($setup.hasExpandedMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode($setup["SimpleToggleComponent"], {
                    fieldId: "formMode",
                    statusOff: $setup.t('message.normal'),
                    statusOn: $setup.t('message.expanded'),
                    "data-testid": "header-mode-toggle"
                  }, null, 8 /* PROPS */, ["statusOff", "statusOn"])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createVNode($setup["LanguageSwitch"], null, null, 512 /* NEED_PATCH */), [
                [_vShow, !$setup.getLanguageParams]
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass($setup.formClass)
    }, [
      _createVNode($setup["NavTabs"], {
        steps: $setup.steps,
        "active-step": $setup.activeStep,
        onClicked: $setup.changeStepTo
      }, null, 8 /* PROPS */, ["steps", "active-step"]),
      (!$setup.submit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.steps, (step, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: step.id
              }, [
                ($setup.activeStep === index)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("p", _hoisted_15, _toDisplayString(step.headline[_ctx.$i18n.locale]), 1 /* TEXT */),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step['fields'], (field) => {
                          return (_openBlock(), _createBlock($setup["FieldsComponent"], {
                            key: field.id,
                            "field-data": field
                          }, null, 8 /* PROPS */, ["field-data"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode($setup["ButtonNavigation"], {
                          index: index,
                          totalSteps: $setup.steps.length - 2,
                          submitForm: $setup.submitForm,
                          changeStepTo: $setup.changeStepTo
                        }, null, 8 /* PROPS */, ["index", "totalSteps"]),
                        ($setup.errorMsg !== '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString($setup.errorMsg), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    ($setup.submit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          (_openBlock(), _createBlock(_resolveDynamicComponent($setup.resultComponent), {
            "form-data": $setup.formData,
            "result-data": $setup.resultData
          }, null, 8 /* PROPS */, ["form-data", "result-data"])),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createVNode($setup["Button"], {
                  text: $setup.t('message.prev'),
                  class: "btn-light",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.changeStepTo($setup.activeStep, true)))
                }, null, 8 /* PROPS */, ["text"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}